import ProjectCard from "../components/ProjectCard"
import "./Projects.css"

const Projects = () => {
  const projects = [
    {
      title: "We Neighbour",
      description:
        "A mobile app for resource sharing in apartments. Users can share, borrow, and manage resources within their apartment community.",
      image: "/images/we-neighbour.jpg",
      technologies: ["Flutter", "Node.js", "MongoDB"],
      link: "https://www.weneighbour.live",
    },
    {
      title: "Real-Time Event Ticketing System",
      description: "A real-time event booking system with live seat selection and instant confirmation features.",
      image: "/images/event-ticketing.jpg",
      technologies: ["React", "Spring Boot", "WebSocket"],
      link: "https://ticketing-eight-tau.vercel.app",
    },
    {
      title: "Bookstore Management System",
      description: "A dynamic bookstore application with real-time stock updates, live order tracking, and seamless author, book, and customer management.",
      image: "/images/bookstore.jpg",
      technologies: ["React","JAX-RS"],
      link: "https://book-store-ten-psi.vercel.app/"
    },
    {
      title: "Estate Agent App",
      description: "A platform for finding and renting homes with advanced search filters and virtual tour features.",
      image: "/images/estate-agent.jpg",
      technologies: ["React"],
      link: "https://estateagent.vercel.app",
    },
    {
      title: "Personal Portfolio",
      description: "My previous portfolio website showcasing my projects and skills.",
      image: "/images/portfolio.jpg",
      technologies: ["React","JavaScript"],
      link: "https://chamudithanonis.vercel.app",
    },
  ]

  return (
    <div className="projects-page">
      <section className="projects-hero">
        <div className="container">
          <h1>My Projects</h1>
          <p>A showcase of my work and contributions</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="projects-container">
            {projects.map((project, index) => (
              <ProjectCard key={index} project={project} />
            ))}
          </div>
        </div>
      </section>

      <section className="section project-process">
        <div className="container">
          <h2 className="section-title">My Development Process</h2>
          <div className="process-grid">
            <div className="process-item">
              <div className="process-number">01</div>
              <h3>Research & Planning</h3>
              <p>Understanding requirements, researching solutions, and planning the architecture.</p>
            </div>
            <div className="process-item">
              <div className="process-number">02</div>
              <h3>Design & Prototype</h3>
              <p>Creating wireframes, designing user interfaces, and building interactive prototypes.</p>
            </div>
            <div className="process-item">
              <div className="process-number">03</div>
              <h3>Development</h3>
              <p>Writing clean, efficient code and implementing the planned features.</p>
            </div>
            <div className="process-item">
              <div className="process-number">04</div>
              <h3>Testing & Deployment</h3>
              <p>Thorough testing, bug fixing, and deploying the application to production.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Have a project in mind?</h2>
            <p>I'm always open to discussing new projects and creative ideas.</p>
            <a href="/contact" className="btn">
              Let's Talk
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Projects

